import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from "./store";
import { PersistGate } from 'redux-persist/integration/react'
import App from './App';
import './App.css'
import reportWebVitals from './reportWebVitals';
// import { BrowserRouter } from "react-router-dom";
import { persistStore } from 'redux-persist';
import './App.css'

let persistor = persistStore(store);
const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      
      <App />
    </PersistGate>
  </Provider>
);
reportWebVitals();

